import * as actions from './actions'
import { ReportsState } from './model'
import { ReportsActions } from './actions'

const initialState: ReportsState = <ReportsState> {}

const reducer = (state: ReportsState = initialState, action: ReportsActions): ReportsState => {
  switch (action.type) {
    case actions.Loading:
      return {
        ...state,
        isLoading: true,
        applicationsData: []
      }
    
    case actions.ChangeApplications:
      return {
        ...state,
        applications: action.payload.data
      }
    
    case actions.ChangeApplicationsData:
      return {
        ...state,
        isLoading: false,
        applicationsData: action.payload.data
      }

    case actions.ChangeApplicationsARM:
      return {
        ...state,
        applicationsARM: action.payload.data
      }

    case actions.ChangeSelectedType:
      return {
        ...state,
        selectedType: action.payload.selectedType
      }
    
    default:
      return state
  }
}

export default reducer
